import { getHostAssetUrl } from 'utils/get-host-asset-url';

export const DASHBOARD_ICONS = {
	// Email Stats Card Icons
	emailIcon: getHostAssetUrl('/media/email_icon.svg'),
	vectorIcon: getHostAssetUrl('/media/Vector.svg'),
	emailBouncedIcon: getHostAssetUrl('/media/email_bounced_icon.svg'),

	// Session Stats Card Icons
	totalSessionsIcon: getHostAssetUrl('/media/total_sessions_icon.svg'),
	onboardingIcon: getHostAssetUrl('/media/onboarding_icon.svg'),
	completedIcon: getHostAssetUrl('/media/completed_icon.svg'),
	reviewIcon: getHostAssetUrl('/media/review_icon.svg'),
	failedIcon: getHostAssetUrl('/media/failed_icon.svg'),
	pendingIcon: getHostAssetUrl('/media/pending_icon.svg'),

	// Shortcuts Section Icons
	onboardShortcut: getHostAssetUrl('/media/onboard_shortcut.svg'),
	esignShortcut: getHostAssetUrl('/media/esign_shortcut.svg'),
};
